import React, { useEffect, useState } from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { LoginResponseType, UserType } from "../../../redux/auth/authTypes";
import { UserStatusDataType } from "../../../screens/AllUsersAndClients";
import { CircularAvatar, ToggleSwitch } from "../../commons";
import "./Toggal.scss";
import { tableEditIcon } from "../../../assets/images";
import {
  formatDate,
  formateDateTime,
  formateDateWithTime,
} from "../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import { RecruitmentSortingType } from "../../../commonTypes/hrmsTypes";
type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: UserType[] | [];
  handleConfirmationModal: () => void;
  handleSetUserStatusChangeData: (data: UserStatusDataType) => void;
  loginData: LoginResponseType;
  allActiveStatus: [] | number[];
  history: any;
  type: string;
  userSearchData?: string;
  departmentFilterValue?: { value: null | string; label: string };
  employmentStatusFilterValue?: { value: null | string; label: string };
  sortBy?: RecruitmentSortingType;
};

const UsersTableData = ({
  tableHeaders,
  data,
  handleConfirmationModal,
  handleSetUserStatusChangeData,
  loginData,
  allActiveStatus,
  history,
  type,
  userSearchData,
  departmentFilterValue,
  employmentStatusFilterValue,
  sortBy,
}: AppProps) => {
  const [toggle, setToggle] = useState(false);
  const [isEditInternalPresent, setIsEditInternalPresent] = useMenuCheck();
  const [isEditExternalPresent, setIsEditExternalPresent] = useMenuCheck();
  const handleToggal = () => {
    setToggle(!toggle);
  };

  const persistedTab = history?.location?.state?.tabs;

  useEffect(() => {
    setIsEditInternalPresent("Edit Internal Users", "menu");
    setIsEditExternalPresent("Edit External Users", "menu");
  }, []);

  useEffect(() => {
    if (toggle) {
    }
  }, [toggle]);
  const handleEnableDisableClick = (data: any) => {
    handleConfirmationModal();
    let finalData: UserStatusDataType = {
      name: `${data?.first_name} ${data?.last_name}`,
      is_active: data?.is_active,
      user_id: data?.user_id,
      type: type === "internal-user" ? "Internal Users" : "External Users",
    };
    handleSetUserStatusChangeData(finalData);
  };

  const handleEditProfileDetails = (userData: UserType | any) => {
    window.scrollTo(0, 0);
    history.push({
      // pathname: `profile/edit/${userData.user_id}`,
      pathname: `all-users/edit-${type}/${userData.user_id}`,
      state: {
        userData,
        allActiveStatus,
        tabs: persistedTab,
        userSearchData,
        departmentFilterValue,
        employmentStatusFilterValue,
        sortBy,
      },
    });
  };

  const renderTableData = () => {
    let finalTableData =
      data?.length > 0 &&
      data?.map((userData: UserType | any, index: number) => {
        return (
          <tr key={userData?.user_id}>
            {tableHeaders?.length > 0 &&
              tableHeaders?.map((header: TableHeadersType) => {
                if (header?.value === "name") {
                  return (
                    <td style={{ width: "240px" }}>
                      <div
                        className="ml-2"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <CircularAvatar
                          name={`${userData?.first_name} ${userData?.last_name}`}
                          image={
                            userData?.profile_pic &&
                            userData?.profile_pic?.file_url
                          }
                        />
                        <div>
                          {`${userData?.first_name} ${userData?.last_name} `}
                          {/* {`${userData?.first_name} ${userData?.last_name} `} */}
                        </div>
                      </div>
                    </td>
                  );
                } else if (header?.value === "email") {
                  return (
                    <td style={{ whiteSpace: "nowrap" }}>
                      {userData?.email?.length > 25 ? (
                        <>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-filter-invoice">
                                {/* {userData?.email} */}
                                {userData?.email}
                              </Tooltip>
                            }
                          >
                            <span>
                              {userData?.email.toLowerCase()?.substr(0, 20) +
                                (userData?.email && userData?.email?.length > 20
                                  ? "..."
                                  : "")}
                            </span>
                          </OverlayTrigger>
                          <br></br>
                          <span style={{ color: "#6e7491", fontSize: "12px" }}>
                            {userData?.mobile && userData?.mobile}
                          </span>
                        </>
                      ) : (
                        <>
                          {userData?.email}
                          <br></br>
                          <span style={{ color: "#6e7491", fontSize: "12px" }}>
                            {userData?.mobile && userData?.mobile}
                          </span>
                        </>
                      )}
                    </td>
                  );
                }
                // else if (header?.value === "mobile") {
                //   return (
                //     <td style={{maxWidth:"120px"}} >{userData?.mobile?userData?.mobile:"NA"}</td>
                //   );
                // }
                else if (header?.value === "job_title") {
                  return (
                    <>
                      <td style={{ whiteSpace: "nowrap", fontSize: "14px" }}>
                        {userData?.job_title}
                        {!userData?.job_title && !userData?.department && "NA"}
                        <br></br>
                        <span style={{ color: "#6e7491", fontSize: "12px" }}>
                          {userData?.department}
                        </span>
                      </td>
                    </>
                  );
                } else if (header?.value === "user_group") {
                  return (
                    <td style={{ minWidth: "130px" }}>
                      <div>
                        {/* // style={{ color: "white", width: "fit-content", margin: "auto", background: userData?.group_name && COLOR_CODES[Math.floor(Math.random() * COLOR_CODES?.length)] }}> */}
                        {userData?.group_name}
                      </div>
                    </td>
                  );
                } else if (header?.value === "updated_by") {
                  return (
                    <td style={{ minWidth: "180px" }}>
                      <UpdatedByAndUpdatedAt
                        firstName={JSON.parse(userData?.updated_by)?.first_name}
                        lastName={JSON.parse(userData?.updated_by)?.last_name}
                        profilePic={
                          JSON.parse(userData?.updated_by)?.profile_pic
                        }
                        updatedAt={formateDateWithTime(userData?.updated_at)}
                      />
                    </td>
                  );
                } else if (
                  header?.value === "employment_status" &&
                  type === "internal-user"
                ) {
                  return (
                    <td>
                      <div
                        className={
                          userData?.employment_status === "Full time"
                            ? `status-complete`
                            : userData?.employment_status === "Part time"
                            ? "status-incomplete"
                            : userData?.employment_status === "Intern"
                            ? "status-approval-pending"
                            : userData?.employment_status === "Probation"
                            ? "manufacturing-journal"
                            : userData?.employment_status === "Articleship"
                            ? "status-other"
                            : ""
                        }
                        style={{
                          borderRadius: "16px",
                          width: "85%",
                          textAlign: userData?.employment_status
                            ? "center"
                            : "center",
                          marginTop: "5px",
                        }}
                      >
                        {userData?.employment_status
                          ? userData?.employment_status
                          : "NA"}
                      </div>
                    </td>
                  );
                } else if (header?.value === "joining_date") {
                  return (
                    <td>
                      {userData?.joining_date
                        ? formatDate(userData?.joining_date)
                        : "NA"}
                    </td>
                  );
                } else if (header?.value === "status") {
                  return (
                    <td style={{ maxWidth: "80px" }}>
                      {userData?.is_active === 0 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "3px",
                          }}
                        >
                          <label className="switchs m-0">
                            <input
                              type="checkbox"
                              checked={userData?.is_active === 0 ? false : true}
                              onChange={() =>
                                handleEnableDisableClick(userData)
                              }
                              disabled={
                                loginData?.email === userData?.email
                                  ? true
                                  : false
                              }
                            />
                            <span
                              className="sliders rounds"
                              style={{
                                backgroundColor:
                                  loginData?.email === userData?.email
                                    ? "gray"
                                    : "",
                              }}
                            ></span>
                          </label>
                          <span>{/* Disabled */}</span>
                        </div>
                      ) : (
                        <div>
                          {loginData?.email == userData.email ? (
                            <button
                              style={{ visibility: "hidden" }}
                              className="btn btn-outline"
                            >
                              {/* Disable */}
                            </button>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                                gap: "3px",
                              }}
                            >
                              <label className="switchs m-0">
                                <input
                                  type="checkbox"
                                  checked={
                                    userData?.is_active === 0 ? false : true
                                  }
                                  onChange={() =>
                                    handleEnableDisableClick(userData)
                                  }
                                  disabled={
                                    loginData?.email === userData?.email
                                      ? true
                                      : false
                                  }
                                />

                                <span
                                  className="sliders rounds"
                                  style={{
                                    backgroundColor:
                                      loginData?.email === userData?.email
                                        ? "gray"
                                        : "",
                                  }}
                                ></span>
                              </label>
                              {/* Enabled */}
                            </div>
                          )}
                        </div>
                      )}
                    </td>
                  );
                } else {
                  return <td> NA </td>;
                }
              })}
            <td style={{ textAlign: "center", width: "50px" }}>
              {((isEditExternalPresent && type === "external-user") ||
                (isEditInternalPresent && type === "internal-user")) && (
                <span
                  className="d-inline-block pointer"
                  onClick={() => handleEditProfileDetails(userData)}
                >
                  <div
                    style={{
                      color: "#d43",
                      fontSize: 20,
                    }}
                  >
                    <img src={tableEditIcon} alt="edit" />
                  </div>
                </span>
              )}
            </td>
            {/* } */}
          </tr>
        );
      });

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default UsersTableData;
